import { BarceloComponent } from "components-utils";

const FASTBOOKING_MOBILE_DELAY = 0;

const StructureComponents = {
  hightlightServiceBanner: BarceloComponent({
    selector: ".c-hightlights-services-banner",
    path: "barcelo/structure/highlights-services-banner/js/hightlight-service-banner",
  }),

  hotelRoyalLevel: BarceloComponent({
    selector: ".hotel-royal-level",
    path: "barcelo/structure/hotel-royal-level/js/hotel-royal-level",
  }),

  modalService: BarceloComponent({
    selector: ".c-modal",
    path: "barcelo/structure/modal-service/js/modal-service",
    enableObserver: true,
    mobileDelay: 2000,
  }),

  modalMeetingRoom: BarceloComponent({
    selector: ".c-modal-meeting-room",
    path: "barcelo/structure/modal-meeting-room/js/modal-meeting-room",
  }),

  stickyService: BarceloComponent({
    selector: ".sticky-JS, .c-header, .c-ribbon, .c-stripemenu",
    path: "barcelo/structure/sticky-service/js/sticky-service",
  }),

  brands: BarceloComponent({
    selector: ".c-brands",
    path: "barcelo/structure/brands/js/c-brands",
  }),

  header: BarceloComponent({
    selector: ".c-header",
    path: "barcelo/structure/header/js/c-header",
    ignoreViewport: true,
  }),

  calendar: BarceloComponent({
    selector: ".c-fastbooking__submenu-calendar, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/calendar",
    belongsTo: "fastbooking",
    skipInit: true,
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  searchHotel: BarceloComponent({
    selector: ".search-hotel-JS, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/c-search-hotel",
    belongsTo: "fastbooking",
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  destination: BarceloComponent({
    selector: ".destination-JS, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/destination",
    belongsTo: "fastbooking",
    skipInit: true,
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  discount: BarceloComponent({
    selector: ".c-fastbooking__submenu-discount, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/discount",
    belongsTo: "fastbooking",
    skipInit: true,
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  rooms: BarceloComponent({
    selector: ".c-fastbooking__submenu-rooms, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/rooms",
    belongsTo: "fastbooking",
    skipInit: true,
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  fastbooking: BarceloComponent({
    selector: ".fastbooking, .c-fastbooking, .hotel-room-list, .c-hotel-room-list",
    path: "barcelo/structure/fastbooking/js/c-fastbooking",
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  fastbookingLite: BarceloComponent({
    selector: ".fastbooking-lite, .c-fastbooking-lite",
    path: "barcelo/structure/fastbooking-lite/js/c-fastbooking-lite",
    ignoreViewport: true,
    mobileDelay: FASTBOOKING_MOBILE_DELAY,
  }),

  footer: BarceloComponent({
    selector: ".c-refooter, .c-footer",
    path: "barcelo/structure/footer/js/footer",
  }),

  megaMenu: BarceloComponent({
    selector: ".c-megamenu",
    path: "barcelo/structure/header/js/megaMenu",
    belongsTo: "header",
  }),

  subHeader: BarceloComponent({
    selector: ".c-subHeader, .c-subHeader-wrapper, .subHeader-dl-id",
    path: "barcelo/structure/header/js/c-subHeader",
    belongsTo: "header",
  }),

  asideMenu: BarceloComponent({
    selector: ".c-aside-menu",
    path: "barcelo/structure/header/js/asideMenu",
    belongsTo: "header",
  }),

  language: BarceloComponent({
    selector: ".language-JS",
    path: "barcelo/structure/language/js/c-language",
    belongsTo: "header",
  }),

  phoneCC: BarceloComponent({
    selector: ".phoneCC",
    path: "barcelo/structure/header/js/phoneCC",
    belongsTo: "header",
  }),

  heroslider: BarceloComponent({
    selector: ".c-heroslider",
    path: "barcelo/structure/heroslider/js/c-heroslider",
  }),

  hotelMeetingRooms: BarceloComponent({
    selector: ".c-hotel-meeting-rooms",
    path: "barcelo/structure/hotel-meeting-rooms/js/c-hotel-meeting-rooms",
  }),

  hotelRoyal: BarceloComponent({
    selector: ".hotel-royal",
    path: "barcelo/structure/hotel-royal/js/hotel-royal-colors",
  }),

  awardsSwiper: BarceloComponent({
    selector: ".c-awards-swipper",
    path: "barcelo/structure/awards-swipper/js/awards-swipper",
  }),

  highlightsGallery: BarceloComponent({
    selector: ".c-highlights-swiper",
    path: "barcelo/structure/highlights-gallery/js/highlights-gallery",
  }),

  customModal: BarceloComponent({
    selector: ".tingle-custom-modal-JS, .c-modal, .tingle-modal",
    path: "barcelo/structure/custom-modal/js/custom-modal",
  }),

  headerDetail: BarceloComponent({
    selector: ".c-header-detail, .wizardModal-JS",
    path: "barcelo/structure/header-detail/js/c-header-detail",
  }),

  campaignGenericComponentGroup: BarceloComponent({
    selector: ".campaign-group-fb-JS",
    path: "barcelo/structure/campaign-generic-group/js/c-campaign-generic-component-group",
  }),

  localeConfigurationForm: BarceloComponent({
    selector: ".locale-form-JS",
    path: "barcelo/structure/locale-configuration-form/js/c-locale-configuration-form",
  }),

  headHotelInfo: BarceloComponent({
    selector: ".c-head-hotel-info",
    path: "barcelo/structure/head-hotel-info/js/c-head-hotel-info",
  }),

  uspCampaign: BarceloComponent({
    selector: ".mod--usp-campaign",
    path: "barcelo/structure/usp-campaign/js/usp-campaign",
  }),

  mybAuthUser: BarceloComponent({
    selector: ".myb-auth-user-section, .myb-auth-user-dl-id",
    path: "barcelo/structure/myb-auth-user/js/c-myb-auth-user",
    ignoreViewport: true,
  }),

  breadcrumb: BarceloComponent({
    selector: ".cmp-breadcrumb",
    path: "barcelo/structure/breadcrumb/js/c-breadcrumb",
  }),
};

export default StructureComponents;
